import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  padding: 1.5rem;

  & > button {
    align-self: center;
    width: 100%;
    max-width: 19.5rem;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & > div {
    &:first-of-type {
      font-family: ${({ theme }) => theme.fonts.grotesk};
      font-weight: 900;
      font-size: 1.25rem;
    }
  }
`;

const Lock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  font-size: 0.875rem;
  font-weight: 600;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const NFT = styled.div`
  position: relative;
  width: fit-content;
  align-self: center;

  background-color: ${({ theme }) => theme.colors.surfaceScores};
  border: 1px solid ${({ theme }) => theme.colors.borderNFT};
  border-radius: 1rem;
  overflow: hidden;

  max-width: 19.5rem;
  max-height: 19.5rem;

  & > img {
    width: 100%;
    height: 100%;

    object-fit: contain;
  }
`;

export default {
  Container,
  Header,
  Lock,
  NFT,
};
